import { render, staticRenderFns } from "./RoleAndRightAssignments.vue?vue&type=template&id=64ed291d&scoped=true&"
import script from "./RoleAndRightAssignments.vue?vue&type=script&lang=js&"
export * from "./RoleAndRightAssignments.vue?vue&type=script&lang=js&"
import style0 from "./RoleAndRightAssignments.vue?vue&type=style&index=0&id=64ed291d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed291d",
  null
  
)

export default component.exports